<template>
  <Loading v-if="isLoading" />
  <template v-else>
    <div v-if="soldOut" class="center not_found" style="width: 100%">
      此產品已全部售出。
    </div>
    <div id="myCalendarView" v-else>
      <span class="close_btn" @click.prevent.stop="close"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          class="bi bi-x-lg"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
          />
          <path
            fill-rule="evenodd"
            d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
          /></svg
      ></span>
      <div class="myDatepicker" style="position: relative">
        <div id="cal">
          <div class="header">
            <span class="left button" id="prev"
              ><i class="fas fa-chevron-left"></i
            ></span>
            <span class="month-year" id="label"></span>
            <span class="right button" id="next"
              ><i class="fas fa-chevron-right"></i
            ></span>
          </div>
          <table id="days">
            <td>Sun</td>
            <td>Mon</td>
            <td>Tue</td>
            <td>Wed</td>
            <td>Thu</td>
            <td>Fri</td>
            <td>Sat</td>
          </table>
          <div id="cal-frame"></div>
        </div>
        <table class="keys">
          <tr>
            <td>
              <span class="gurantee"></span>
            </td>
            <td style="width: 70px">已成團</td>
            <td>
              <span class="will_gurantee"></span>
            </td>
            <td>快將成團</td>
          </tr>
        </table>
      </div>
    </div>
  </template>
</template>

<script>
import { ref, nextTick, onMounted } from "vue";
import { CALENDAR } from "@/dependency/calendar/calendar.js";
import "@/dependency/calendar/calendar.css";
import ApiService from "@/services/ApiService.js";
import useEventBus from "@/config/eventBus";

export default {
  props: {
    productId: {
      type: Number,
      required: true,
    },
    productCode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const reserveMonths = 12;
    const isLoading = ref(true);
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const soldOut = ref(true);
    const priceList = ref([]);
    const eventBus = useEventBus();

    const _retrievePrice = async (_currentMonth, _currentYear) => {
      return new Promise((resolve) => {
        ApiService.getPrice({
          code: props.productCode,
          date: String(_currentYear).concat(
            String(("0" + _currentMonth).slice(-2))
          ),
          itemId: props.productId,
        }).then((res) => {
          if (res.ismDayPriceResponse.length > 0) {
            res.ismDayPriceResponse.forEach(function (e) {
              if (
                e.productCode == props.productCode &&
                e.confirmStatus != "售罄"
              ) {
                priceList.value.push(e);
              }
            });
          }
          resolve();
        });
      }).catch((error) => {
        throw new Error(`API ${error}`);
      });
    };

    const close = () => eventBus.emit("closeModal");

    const handleNextTick = async () => {
      await nextTick();
      setTimeout(function () {
        if (priceList.value.length > 0) {
          $("#cal-frame").html("");
          let thisMonth = "";
          let thisYear = "";
          let minMonth = "";
          let minYear = "";
          let maxMonth = "";
          let maxYear = "";
          const apiLength = priceList.value.length;
          thisMonth = priceList.value[0]["useDate"].substring(5, 7);
          thisYear = priceList.value[0]["useDate"].substring(0, 4);
          minMonth = thisMonth;
          minYear = thisYear;
          maxMonth = priceList.value[apiLength - 1]["useDate"].substring(5, 7);
          maxYear = priceList.value[apiLength - 1]["useDate"].substring(0, 4);
          console.log(minMonth, minYear, maxMonth, maxYear);
          let cal = CALENDAR();
          cal.init();
          $('#label').text("");
          console.log(thisMonth);          
          cal.switchMonth(true, thisMonth - 1, thisYear);          
          priceList.value.forEach((item) => {
            item.originalPrice = item.sellingPrice;
          });
          console.log(minMonth, minYear, maxMonth, maxYear);
          cal.fillPriceAndKey(priceList.value);
          cal.checkMonthAndYear(minMonth, minYear, maxMonth, maxYear);
          $(".button").click(function () {
            cal.fillPriceAndKey(priceList.value);
            cal.checkMonthAndYear(minMonth, minYear, maxMonth, maxYear);
          });
          $("#cal-frame").click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            let target;
            let useDate;
            let price;
            let itemId;
            target = $(e.target);
            $("#cal-frame td").css({ border: "1px solid #a4f1f4" });
            if (target.closest("td").hasClass("active")) {
              useDate = target.closest("td").attr("class").substring(0, 10);
              price = target
                .closest("td")
                .find(".price span")
                .text()
                .substring(1);
              itemId = target.closest("td").find(".price b.itemId").text();
              target.closest("td").css({ border: "2px solid #00d7e1" });
              eventBus.emit("selectDateEvent", {
                productId: props.productId,
                itemId: itemId,
                price: price,
                useDate: useDate,
              });
            }
          });
        }
      }, 200);
    };

    const retrievePrice = (_currentMonth, _currentYear) => {
        return new Promise((resolve) => {
          ApiService.getPrice({
            code: props.productCode,
            date: String(_currentYear).concat(
              String(("0" + _currentMonth).slice(-2))
            ),
            itemId: props.productId,
          }).then((res) => {
            if (res.ismDayPriceResponse.length > 0) {
              res.ismDayPriceResponse.forEach(function (e) {
                if (
                  e.productCode == props.productCode &&
                  e.confirmStatus != "售罄"
                ) {
                  priceList.value.push(e);
                }
              });
            }
            resolve();
          });
        }).catch((error) => {
          throw new Error(`API ${error}`);
        });
      };
    
    onMounted(async () => {
        /*
        const promises = [];
    	for (let i = 0; i < reserveMonths; i++) {
            let currentMonth = parseInt(month) + i;
            let currentYear = parseInt(year);
            if (currentMonth > 12) {
              currentMonth -= 12;
              currentYear += 1;
            }
            promises.push( retrievePrice(currentMonth, currentYear));    
          }
    	const isFinish = Promise.all(promises);
    	isFinish.then(function (data){
    		priceList.value.sort((a,b)=> a.useDate-b.useDate);
    		if (priceList.value.length > 0) soldOut.value = false;
        	isLoading.value = false;
        	handleNextTick();	
        });    	
        */
      for (let i = 0; i < reserveMonths; i++) {
        let currentMonth = parseInt(month) + i;
        let currentYear = parseInt(year);
        if (currentMonth > 12) {
          currentMonth -= 12;
          currentYear += 1;
        }
        await retrievePrice(currentMonth, currentYear);        
        if (priceList.value.length > 0) soldOut.value = false;
        if (i == reserveMonths - 1) {
          /*
          if (priceList.value.length > 0) {
            priceList.value = priceList.value.sort(function (a, b) {
              return new Date(a.useDate) - new Date(b.useDate);
            });
          }
          */
          isLoading.value = false;
          handleNextTick();
        }
      }
      
    });

    return {
      isLoading,
      soldOut,
      close,
    };
  },
};
</script>

<style scoped>
#myCalendarView {
  position: relative;
}
</style>
